import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: "root",
})
export class HttpService {
	constructor(private http: HttpClient) {}

	public post(
		endpoint: string,
		body?: any,
		header?: HttpHeaders,
		isAdmin: boolean = true,
		isRest: boolean = false
	) {
		return this.http.post<any>(this.getUrl(endpoint, isAdmin, isRest), body, {
			headers: header,
		});
	}

	public get(
		endpoint: string,
		params?: any,
		header?: HttpHeaders,
		isAdmin: boolean = true,
		isRest: boolean = false
	) {
		return this.http.get<any>(this.getUrl(endpoint, isAdmin, isRest), {
			headers: header,
			params: params,
		});
	}

	public put(
		endpoint: string,
		body?: any,
		header?: HttpHeaders,
		isAdmin: boolean = true,
		isRest: boolean = false
	) {
		return this.http.put<any>(this.getUrl(endpoint, isAdmin, isRest), body, {
			headers: header,
		});
	}

	public delete(
		endpoint: string,
		body?: any,
		header?: HttpHeaders,
		isAdmin: boolean = true,
		isRest: boolean = false
	) {
		return this.http.delete<any>(this.getUrl(endpoint, isAdmin, isRest), {
			headers: header,
			body: body,
		});
	}

	private getUrl(endpoint: string, isAdmin: boolean, isRest: boolean) {
		return (
			(isRest ? environment.countries.url : environment.api.url) +
			(isAdmin &&
			!endpoint.includes(environment.api.auth) &&
			!endpoint.includes(environment.api.refresh)
				? environment.api.web
				: "") +
			endpoint
		);
	}
}
